import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { Col, Row } from "react-styled-flexboxgrid";
import PageSection, { StyledSectionHeading } from "../components/PageSection";
import { siteTitle } from "../data/PublicSiteData";
import { trackPageView } from "../includes/analytics";
import Public from "../Layouts/Public";
import { Color } from "../theme/Color";

const Cookies = () => {
  const router = useRouter();

  trackPageView("/cookie-policy");

  return (
    <>
      <NextSeo
        title={`Cookie Policy | ${siteTitle}`}
        description="Valmeego is a new way for destinations and visitors to interact online.
Get inspiration, local knowledge, advice & deals directly from any destination."
      />
      <PageSection
        backgroundColor={Color.White}
        width="1340px"
        data-cy="core-values"
      >
        <StyledSectionHeading center="xs">Cookie Policy</StyledSectionHeading>
        <Row center="xs" middle="xs">
          <Col
            xs={10}
            md={8}
            style={{ color: Color.Grey2, marginBottom: "5rem" }}
          >
            <h2>Information about Valmeegos use of Cookies</h2>

            <p>
              We use cookies and similar technologies on our website, web
              applications, email communications and advertisements for a number
              of purposes including authentication of users, maintaining user
              preferences and settings, determining the popularity of content,
              measuring the effectiveness of our marketing campaigns, analysing
              site traffic and trends and understanding our users&rsquo; online
              behaviours and interests.
            </p>

            <p>
              This cookie policy is intended to inform you about the cookies we
              use and why we use them. It also informs you how to change or
              restrict how cookies are used on your devices. This policy should
              be read in conjunction with our Privacy Policy, which explains how
              we use personal information.
            </p>

            <p>
              We will ask your permission to set cookies on your device, except
              where these are essential for the operation of our website.
            </p>

            <h3>Cookies Overview</h3>

            <p>
              A Cookie is a small piece of data that is stored on your browser
              or device by websites, progressive web applications, online media
              and advertisements that are used to remember your browser/ device
              during and across website visits. Cookies enable us to retrieve
              among other things, your user settings, and preferences.
            </p>

            <h3>Why do we use Cookies?</h3>

            <p>
              We use cookies for a variety of legitimate business purposes
              including:
            </p>

            <ul>
              <li>
                For the operation of our progressive web application and
                services
              </li>
              <li>
                To improve your user experience, by remembering your preferences
                and settings we can make it easier and faster to navigate
                through our services.
              </li>
              <li>
                To provide you with a more personalised experience, such as
                making content recommendations, personalising your visits, and
                greeting you by name.
              </li>
              <li>
                Enabling basic functions such as assisting with account login,
                page navigation and access to secure areas of the website.
              </li>
              <li>To simplify sign-in procedures.</li>
              <li>To support our advertising services.</li>
              <li>
                To determine the effectiveness of promotional campaigns, email
                campaigns and advertising.
              </li>
              <li>
                To ensure content from our site and mobile applications is
                presented in the most effective manner for you and for your
                device.
              </li>
            </ul>

            <h3>Types and purposes of Cookies:</h3>

            <h4>Strictly necessary</h4>

            <p>
              These cookies are essential to enable your use of the site or
              services, such as setting your privacy preferences, logging in,
              filling in forms, account information or trip history. They may
              also provide authentication, site security, and help localise the
              language based on the geography of your visit.
            </p>

            <h4>Functionality cookies</h4>

            <p>
              These cookies enable our website to provide enhanced functionality
              and personalisation. We may also use cookies and similar
              technologies to help us provide you and others with social
              plug-ins and other customised content and experiences. If you do
              not allow these cookies, then some or all of these services may
              not function properly. Some third-party functional cookies may
              track your browser across other sites and build up a profile of
              your interests. This may impact the content and messages you see
              on other sites you visit.
            </p>

            <h4>Performance Cookies</h4>

            <p>
              Analytical cookies are used to understand, improve, and research
              products and services. We collect statistical information about
              our users, including when you access the Valmeego website and
              progressive web application from a computer or mobile devices. We
              use these cookies to understand how you are using our site
              features, segment audiences for feature testing and determine the
              kind of content and services our users value most. Analytics
              cookies are set by Valmeego and Google Analytics.
            </p>

            <p>
              To opt out of being tracked by Google Analytics across all
              websites, please visit Google Analytics Opt-out Browser Add-on
              Download Page . On this website you&rsquo;ll find information
              about a browser plug-in that can be installed to prevent your data
              from being used by Google Analytics.
            </p>

            <h4>Targeting Cookies</h4>

            <p>Valmeego.com use third-party cookies.</p>

            <p>
              These cookies are used to deliver personalised advertisement both
              on Valmeego.com and other websites. Track email marketing or ad
              campaign performance and efficiency. These adverts are based on
              your browsing such as businesses, Ameego&rsquo;s and activities
              you have viewed and clicked through to. These cookies are also
              used to integrate social media on our site allowing you to like or
              share pages on social media.
            </p>

            <p>
              For example, through these cookies we serve you ads that are
              relevant to you based on inferred interests. Create a browsing
              profile that is used to deliver more relevant ads. Measure the
              effectiveness of the ads that are served. Detect fraudulent
              traffic.
            </p>

            <h4>Social-media cookies</h4>

            <p>
              These cookies are set by a range of social media services that we
              have added to our site to enable you to share our content with
              your friends and networks. They can track your browser across
              other sites and build up a profile of your interests. This may
              impact the content and messages you see on other websites you
              visit. If you do not allow these cookies, you may not be able to
              use or see these sharing tools.
            </p>

            <h3>Managing your cookie preferences</h3>

            <p>
              Cookies are meant to improve your user experience, but some users
              prefer to set restrictions on the types of cookies that can be
              stored on their device. If you do not allow these cookies, then
              some or all of these services may not function properly.
            </p>

            <h3>
              <br />
              Updates to this policy
            </h3>

            <p>
              We may update our cookie policy to reflect any changes in
              technology or protection legislation. Any updates or changes that
              may affect how we use cookies will appear on this page. We will
              notify you by posting a notice on our website, and where
              appropriate send you a notification.
            </p>

            <p>&nbsp;</p>
          </Col>
        </Row>
      </PageSection>
    </>
  );
};

Cookies.Layout = Public;

export default Cookies;
